import { Clock, MapPin, MessageCircle, Phone, Recycle } from "lucide-react";
import { HOURS, PHONE_DISPLAY, PHONE_TEL, SERVICE_AREAS, waLink } from "../../data/site";

export default function Footer() {
  return (
    <footer id="contact" data-testid="footer" className="border-t border-white/10 bg-ink pb-24 pt-20 text-white md:pb-10">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="grid gap-14 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <a href="#top" className="flex items-center gap-2.5" data-testid="footer-logo">
              <span className="flex h-10 w-10 items-center justify-center bg-mint text-ink">
                <Recycle className="h-6 w-6" />
              </span>
              <span className="font-display text-2xl font-bold tracking-tight">
                A R <span className="text-mint">Scrap</span> Enterprises
              </span>
            </a>
            <p className="mt-6 max-w-sm text-sm leading-relaxed text-white/60">
              Bangalore's most trusted scrap buying service for 10+ years. Copper, aluminum, brass,
              SS, MS, office, battery, machinery, generator, AC, industrial and demolition scrap —
              best market rates, free pickup and same-day payment.
            </p>
            <div className="mt-8 space-y-3 font-mono text-xs uppercase tracking-[0.16em] text-white/70">
              <a
                href={PHONE_TEL}
                data-testid="footer-call-link"
                className="flex items-center gap-3 transition-colors duration-200 hover:text-mint"
              >
                <Phone className="h-4 w-4 text-mint" /> {PHONE_DISPLAY}
              </a>
              <p className="flex items-center gap-3">
                <Clock className="h-4 w-4 text-mint" /> {HOURS}
              </p>
            </div>
            <a
              href={waLink()}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-whatsapp-button"
              className="mt-8 inline-flex items-center gap-2.5 rounded-full bg-wa px-6 py-3.5 text-sm font-semibold text-white shadow-lg shadow-black/25 transition-transform duration-200 hover:scale-[1.03]"
            >
              <MessageCircle className="h-4 w-4" />
              Get Quote on WhatsApp
            </a>
          </div>

          <div className="lg:col-span-7">
            <p className="flex items-center gap-2 font-mono text-[11px] font-semibold uppercase tracking-[0.3em] text-mint">
              <MapPin className="h-4 w-4" /> Service Areas — Bangalore
            </p>
            <div className="mt-6 grid grid-cols-2 gap-3 sm:grid-cols-3" data-testid="footer-service-areas">
              {SERVICE_AREAS.map((area) => (
                <span
                  key={area}
                  className="border border-white/10 bg-white/5 px-4 py-3 font-mono text-[11px] uppercase tracking-[0.14em] text-white/70 transition-colors duration-200 hover:border-mint/50 hover:text-white"
                >
                  {area}
                </span>
              ))}
            </div>
            <p className="mt-8 text-sm leading-relaxed text-white/50">
              Searching for a "scrap buyer near me"? We reach every corner of Bangalore — same-day
              for bulk industrial, commercial and demolition scrap.
            </p>
          </div>
        </div>

        <div className="mt-16 select-none overflow-hidden" aria-hidden="true">
          <p className="whitespace-nowrap font-display text-[11vw] font-bold uppercase leading-none tracking-tight text-stroke-white lg:text-[7vw]">
            Scrap · Sell · Recycle
          </p>
        </div>

        <div className="mt-10 flex flex-wrap items-center justify-between gap-4 border-t border-white/10 pt-8 font-mono text-[10px] uppercase tracking-[0.2em] text-white/40">
          <p>© {new Date().getFullYear()} A R Scrap Enterprises</p>
          <p>Scrap Buyers in Bangalore · Best Price Guaranteed</p>
        </div>
      </div>
    </footer>
  );
}
